import { render, staticRenderFns } from "./menuVisitas.vue?vue&type=template&id=6ea6de4e"
import script from "./menuVisitas.vue?vue&type=script&lang=js"
export * from "./menuVisitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports